import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { enableNetworkElementAutoSwitch } from '@api/networkElements';

import { TNetworkElementAutoSwitchDTO } from '@interfaces/networkElements/dto/networkElements';
import { INetworkElement } from '@interfaces/networkElements/networkElements';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { NETWORK_ELEMENTS_ENABLE_AUTO_SWITCH } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateNetworkElements from './useInvalidateNetworkElements';

interface IUseMutateNetworkElementEnableAutoSwitchReturned {
	enableNetworkElementAutoSwitch: (dto: TNetworkElementAutoSwitchDTO) => void;
	isLoadingEnableNetworkElementAutoSwitch: boolean;
}

const useMutateNetworkElementEnableAutoSwitch = (
	handleCloseModal: () => void,
): IUseMutateNetworkElementEnableAutoSwitchReturned => {
	const dispatch = useAppDispatch();
	const invalidateNetworkElements = useInvalidateNetworkElements();

	const {
		isLoading,
		mutate,
	} = useMutation<TNetworkElementAutoSwitchDTO>({
		mutationKey: [NETWORK_ELEMENTS_ENABLE_AUTO_SWITCH],
		mutationFn: enableNetworkElementAutoSwitch,
		onSuccess: (data: INetworkElement) => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.networkElementUpdated(data.name),
				type: ESnackbarTypes.success,
			}));

			return invalidateNetworkElements();
		},
		allowedRoles: [EUserRoles.smoLightUpdater],
	});

	return {
		enableNetworkElementAutoSwitch: mutate,
		isLoadingEnableNetworkElementAutoSwitch: isLoading,
	};
};

export default useMutateNetworkElementEnableAutoSwitch;
